var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLeftWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7639_184803",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 3,
    width: 10,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4116 4.57343C16.7066 4.28243 16.7106 3.80743 16.4196 3.51243C16.1286 3.21843 15.6536 3.21543 15.3586 3.50643L7.58057 11.1764C7.24457 11.5074 7.05957 11.9504 7.05957 12.4224C7.05957 12.8934 7.24457 13.3374 7.58057 13.6684L15.3586 21.3374C15.5046 21.4804 15.6946 21.5524 15.8856 21.5524C16.0786 21.5524 16.2726 21.4774 16.4196 21.3294C16.7106 21.0344 16.7066 20.5594 16.4116 20.2684L8.63457 12.5994C8.56857 12.5364 8.55957 12.4614 8.55957 12.4224C8.55957 12.3834 8.56857 12.3074 8.63457 12.2444L16.4116 4.57343Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7639_184803)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.847656,
    y: 0.420898,
    width: 24,
    height: 24,
    fill: "#FFFDFD"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftWhite);
export default __webpack_public_path__ + "static/media/arrowLeftWhite.ef81d2a7e94091e5685fb3a7dd52ec27.svg";
export { ForwardRef as ReactComponent };